import { useNavigate, useSearchParams } from 'react-router-dom';
import {
	Layout,
	message,
	Row,
	Col,
	Card,
	Form,
	Input,
	Button,
	Typography,
	notification,
	Checkbox,
	Spin
} from 'antd';
import { resetPasswordRedux } from '../../store/auth/actions';
import { useDispatch } from 'react-redux';
import { isMobileOnly } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { CheckCircleOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';

import axios from 'axios';
import env from '../../environment';

const EV = require('../../assets/EngelLogo.png');
const EVMoBile = require('../../assets/EngelLogoMobile.png');

const { Content } = Layout;
const { Text } = Typography;

const ResetPassword = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [reset, setReset] = useState('#808080');

	const [searchParams] = useSearchParams();
	const token = searchParams.get('token');
	const email = searchParams.get('email');
	const [check, setCheck] = useState(false);

	const [checkStates, setCheckStates] = useState({
		minLength: '#808080', // Mínimo 8 caracteres
		maxLength: '#808080', // Máximo 16 caracteres
		lowercase: '#808080', // Mínimo una minúscula
		uppercase: '#808080', // Mínimo una mayúscula
		number: '#808080', // Mínimo un número
		special: '#808080', // Mínimo un símbolo o carácter especial
		noSpace: '#808080' // Sin espacios en blanco
	});

	const [tokenValid, setTokenValid] = useState(false);

	useEffect(() => {
		if (token) {
			validTokenUser(token);
		}
	}, [token]);

	const validTokenUser = (token) => {
		axios
			.post(
				`${env.api.url}/v1/auth/validate-reset-token`,
				{
					email: email,
					token: token,
					managementCode: 'sc-es'
				}
				//{ headers: { Authorization: `Bearer ${token}` } }
			)
			.then((response) => {
				setTokenValid(response.data.valid);
			});
	};

	const onPasswordChange = (password) => {
		setCheckStates({
			minLength: password.length >= 8 ? '#477306' : '#808080', // Mínimo 8 caracteres
			maxLength: password.length <= 16 ? '#477306' : '#808080', // Máximo 16 caracteres
			lowercase: /[a-z]/.test(password) ? '#477306' : '#808080', // Mínimo una minúscula
			uppercase: /[A-Z]/.test(password) ? '#477306' : '#808080', // Mínimo una mayúscula
			number: /\d/.test(password) ? '#477306' : '#808080', // Mínimo un número
			special: /[\W_]/.test(password) ? '#477306' : '#808080', // Mínimo un símbolo o carácter especial
			noSpace: !/\s/.test(password) ? '#477306' : '#808080' // Sin espacios
		});
	};

	const onFinish = async (values) => {
		const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])([^\s]){8,16}$/;

		if (
			regex.test(values.password1) &&
			regex.test(values.password2) &&
			values.password1 === values.password2
		) {
			setReset('#477306');
			const tmp = await dispatch(resetPasswordRedux(token, email, values.password1));

			if (tmp?.success || tmp?.redirectUrl) {
				notification.success({
					message: t('pass.evReset'),
					description: t('pass.evReset2'),
					style: {
						background: '#DFF4D4',
						width: 320,
						borderColor: '#52C41A',
						borderRadius: 4
					}
				});
				const redirectUrl = tmp?.redirectUrl;
				if (redirectUrl && /^https?:\/\//i.test(redirectUrl)) {
					window.location.href = redirectUrl;
				} else {
					navigate(redirectUrl || '/login');
				}
			} else {
				message.error('No se pudo restablecer la contraseña. Por favor, inténtelo de nuevo.');
			}
		} else {
			message.error('Contraseña inválida ❌');
			setReset('#808080');
		}
	};

	const onFinishFailed = () => {
		message.error('Debe completar todos los datos');
	};
	if (tokenValid) {
		return (
			<Layout
				style={{
					width: isMobileOnly ? 400 : undefined,
					marginTop: -5,
					background: '#FCFAF5'
				}}>
				<div style={{ height: isMobileOnly ? 56 : 68, background: 'white' }}>
					<div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
						{isMobileOnly ? (
							<img src={EVMoBile} alt="EV" style={{ width: 109, height: 24 }}></img>
						) : (
							<img src={EV} alt="EV" style={{ width: 212, height: 16 }}></img>
						)}
					</div>
				</div>
				<Content
					style={{
						marginTop: !isMobileOnly ? 32 : undefined,

						height: !isMobileOnly ? '100vh' : undefined,
						padding: isMobileOnly && 24,
						height: '100vh',
						marginRight: !isMobileOnly ? undefined : 8
					}}>
					<div style={{ display: 'flex', justifyContent: 'center', marginBottom: 32 }}>
						<Text style={{ fontSize: isMobileOnly ? 20 : 32, fontWeight: 700, color: '#262626' }}>
							{t('reset.pass')}
						</Text>
					</div>
					<Row justify="space-around" align="middle">
						<Col lg={6} md={12} xs={24} sm={24}>
							<Card className="card-login">
								<Form name="login" onFinish={onFinish} onFinishFailed={onFinishFailed}>
									<Form.Item
										name="password1"
										rules={[
											{
												required: true,
												message: 'Por favor, introduzca su contraseña'
											}
										]}>
										<Input.Password
											onChange={(e) => onPasswordChange(e.target.value)}
											className={'login-input'}
											placeholder={t('login.pass') + '*'}
										/>
									</Form.Item>
									<Form.Item
										name="password2"
										rules={[
											{
												required: true,
												message: 'Por favor, introduzca su contraseña'
											}
										]}>
										<Input.Password className={'login-input'} placeholder={t('login.pass') + '*'} />
									</Form.Item>

									<Form.Item
										name="check"
										rules={[
											{
												required: true,
												message: 'Por favor, acepte los términos y condiciones'
											}
										]}
										style={{ marginTop: isMobileOnly && -20 }}>
										<div style={{ display: 'flex', marginTop: 16 }} className="register2">
											<Checkbox onChange={() => setCheck(!check)}></Checkbox>
											&nbsp;&nbsp;
											<span
												className="check-register"
												dangerouslySetInnerHTML={{ __html: t('register.legalTermsEV') }}
												style={{ fontSize: 16, fontWeight: 400 }}></span>
										</div>
									</Form.Item>

									<Form.Item>
										<Button
											htmlType="submit"
											block
											className="button-secundary-ev"
											style={{ height: isMobileOnly && 48 }}>
											{t('resetPassword.buttonTitle')}
										</Button>
									</Form.Item>
								</Form>
							</Card>

							<div
								style={{
									display: isMobileOnly ? 'column' : 'flex',
									marginTop: 32,
									justifyContent: 'center',
									width: 'max-content'
								}}>
								<div style={{ display: 'flex', flexDirection: 'column' }}>
									<Text
										style={{
											fontSize: 14,
											fontWeight: 400,
											color: checkStates.minLength,
											marginLeft: 8
										}}>
										<CheckCircleOutlined style={{ marginRight: 4 }}></CheckCircleOutlined>
										{t('check.min1')}
									</Text>
									<Text
										style={{
											fontSize: 14,
											fontWeight: 400,
											color: checkStates.lowercase,
											marginLeft: 8
										}}>
										<CheckCircleOutlined style={{ marginRight: 4 }}></CheckCircleOutlined>
										{t('check.min2')}
									</Text>
									<Text
										style={{
											fontSize: 14,
											fontWeight: 400,
											color: checkStates.uppercase,
											marginLeft: 8
										}}>
										<CheckCircleOutlined style={{ marginRight: 4 }}></CheckCircleOutlined>
										{t('check.min3')}
									</Text>
									<Text
										style={{
											fontSize: 14,
											fontWeight: 400,
											color: checkStates.number,
											marginLeft: 8
										}}>
										<CheckCircleOutlined style={{ marginRight: 4 }}></CheckCircleOutlined>
										{t('check.min4')}
									</Text>
								</div>
								<div style={{ display: 'flex', flexDirection: 'column' }}>
									<Text
										style={{
											fontSize: 14,
											fontWeight: 400,
											color: checkStates.special,
											marginLeft: 8
										}}>
										<CheckCircleOutlined style={{ marginRight: 4 }}></CheckCircleOutlined>
										{t('check.min5')}
									</Text>
									<Text
										style={{
											fontSize: 14,
											fontWeight: 400,
											color: checkStates.noSpace,
											marginLeft: 8
										}}>
										<CheckCircleOutlined style={{ marginRight: 4 }}></CheckCircleOutlined>
										{t('check.min6')}
									</Text>
									<Text
										style={{
											fontSize: 14,
											fontWeight: 400,
											color: checkStates.maxLength,
											marginLeft: 8
										}}>
										<CheckCircleOutlined style={{ marginRight: 4 }}></CheckCircleOutlined>
										{t('check.min7')}
									</Text>
								</div>
							</div>
						</Col>
					</Row>
				</Content>
			</Layout>
		);
	} else {
		if (tokenValid === undefined) {
			return (
				<div style={{ textAlign: 'center' }}>
					<Spin style={{ position: 'absolute', top: '50%' }} size="large" />
				</div>
			);
		} else {
			return (
				<Content style={{ marginTop: 24, width: 800, justifySelf: 'center' }}>
					<div
						style={{ display: 'flex', justifyContent: 'center', marginBottom: 32, marginTop: 100 }}>
						<Text style={{ fontSize: isMobileOnly ? 20 : 40, fontWeight: 700, color: '#262626' }}>
							{t('link.titleToken')}
						</Text>
					</div>
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',

							textAlign: 'center'
						}}>
						<Text style={{ fontSize: isMobileOnly ? 20 : 24, fontWeight: 700, color: '#262626' }}>
							{t('link.titleTokenSub')}
						</Text>
					</div>
					<div style={{ display: 'flex', justifyContent: 'center', marginBottom: 32 }}>
						<Button
							onClick={() => navigate('/auth/forgot-password')}
							block
							className={`button-primary-engel`}
							style={{
								height: 48,
								marginTop: isMobileOnly ? 32 : 40,
								width: 200
							}}>
							{t('link.titleTokenBotton')}
						</Button>
					</div>
				</Content>
			);
		}
	}
};

export default ResetPassword;
